import { $t } from '@/i18n';
import {
  XyCosSelectorMeta,
  XyCosSelectorEnvMeta,
} from '../paramsFormComponents';
import uploader from '@utils/upload';
import { CATEGORY } from './const';
import excelAtoms from './excel';
import { isPlainObject } from 'lodash';
import { getFileDataAtom } from './getFileDataAtom';

// 上传至COS
export const uploadToCOSAtom = {
  id: 'xy:source:uploader.uploadToCOS',
  name: $t('k_2b9ae399'),
  category: CATEGORY.EXPORT,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'cosId',
        type: 'string',
        title: $t('k_66897280'),
        'uc:allowInterop': true,
        ui: { type: 'XyCosSelector' },
      },
      {
        id: 'envConfig',
        type: 'object',
        title: $t('k_75eba9b0'),
        ui: { type: 'XyCosEnvSelector' },
      },
      {
        id: 'file',
        type: 'string',
        title: $t('k_8fa91e29'),
      },
      {
        id: 'path',
        type: 'string',
        title: $t('k_5ed30431'),
      },
      {
        id: 'headers',
        type: 'object',
        title: $t('k_ab62831f'),
        description: $t('k_2ab4858f'),
        default: '',
        'uc:allowInterop': true,
        ui: {
          type: 'exprInput',
          props: {
            multipleLine: true,
          },
        },
      },
    ],
  },
  returnValue: {
    type: 'string',
    description: $t('k_39e5732a'),
  },
  paramsFormComponents: [
    XyCosSelectorMeta,
    XyCosSelectorEnvMeta,
  ],
  async execute(ctx, params) {
    const { cosId, envConfig, file, path = '', headers = '' } = params;
    let customHeaders = null;
    if (headers && typeof headers === 'string') customHeaders = ctx.tryEval(headers);
    else if (isPlainObject(headers)) customHeaders = headers;
    const { projectId, env } = window.w;
    const cos = envConfig[env] || cosId;
    if (!file || !cos) {
      throw new Error($t('k_8a717ba0'));
    }
    const data = await uploader.upload({
      file,
      filePath: `/${path.replace(/^\//, '')}`,
      cosId: cos,
      projectId,
      headers: isPlainObject(customHeaders) ? customHeaders : null,
    });
    return data;
  },
};

export default [
  uploadToCOSAtom,
  ...excelAtoms,
  getFileDataAtom,
];
